import { ConnectedPosition } from '@angular/cdk/overlay';

export const FILTER_DROPDOWN_POSITIONS: ConnectedPosition[] = [{
  originX: "start",
  originY: "top",
  overlayX: "start",
  overlayY: "top"
}, {
  originX: "start",
  originY: "top",
  overlayX: "start",
  overlayY: "bottom"
}];
